// import cookie from '../../lib/cookie.js'
import '../assets/scss/hosting.scss'
import ServicesAdd from "./pages/ServicesAdd"
import ServicesEdit from "./pages/ServicesEdit"
import Spinner from 'vue-simple-spinner'
import Vue from "vue"
export default {
	components: {
		ServicesAdd,
		ServicesEdit,
		Spinner
	},
	watch: {
		showStatus(a, b) {
			if (a !== b) {
				this.setStatusFilter();
			}
		},
		perPage(a, b) {
			if (a !== b) {
				// this.clearSelected();
			}
		},
		currentPage(a, b) {
			if (a !== b) {
				// this.clearSelected();
			}
		},
		filter(a, b) {      
			if (a !== b) {
				// this.clearSelected();
			}
		},
	  '$route.path': function(val, oldVal){
	    this.initiate();
	  }
	},
	data() {
			return {
				loading:false,
				checkedItems: [],
				tableValues: [],
				multichoice: '',
				sortBy: 's_domain',
				fields: [	
					{ key: 'S_ID', label: 'ID',sortable: true },
					{ key: 'S_NAME', label: 'Name',sortable: true },
					// { key: 'S_LINKNAME', label: 'Link',sortable: true },
					{ key: 'S_LINKURL', label: 'Link',sortable: true },
					{ key: 'actions', label: 'Actions', 'class': 'text-right'},
				],
				currentPage:1,
				pageOptions: [ 5, 10, 20, 50, 100 ],
				filter: null,
				modalInfo: { title: '', content: '' },
				showeditor: false,
				showadder: false,
				token: '',
				rows: [],
				services:[],
				site: {},
				redirecturl: '',
				newsite: { },
				site_template: {
					'S_NAME':'',
					'S_OTHER':'',
					'S_LINKNAME':'',
					'S_LINKURL':'',
				},
				working:false,
				totalRows: 0,
				perPage: 20,	

				limit: 5,
				currentPage: 1,
				allowedTypes: ['BL', 'B4M'],
				title: ""
			};
	},

	created: function () {
		this.initiate();
	},
	methods: {
		initiate() {
			let that = this
			this.newsite = this.site_template;
			this.loading = true;
			this.$http.get("/services/list", { headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken')}})
				.then(resp => {
					if(resp.data.error) {
						alert("Connection failed: " + resp.data.error)
						//resolve({'loginError':resp.data.error})
					}
					else {
						that.totalRows = parseInt(resp.data.length)
						that.rows = resp.data
						that.services = JSON.parse(JSON.stringify(that.rows))
						that.totalPages = (that.total == 0) ? 0 : Math.ceil(that.total / that.perpage)
						// that.showInventoryChunk(start)
						this.loading = false;
					}
				})
				.catch(err => {
					// localStorage.removeItem('shareXToken') // if the request fails, remove any possible user token if possible
					alert(err)
					this.loading = false;
				})
			},

		closeTheEditor() {
			this.showeditor = false;
			this.showadder = false;
		},
		showAdd() {
			this.showadder = true;
		},
		showEditor() {
			this.showeditor = true;
		},
		resetModal () {
			this.modalInfo.title = ''
			this.modalInfo.content = ''
		},

		details(index,item) {
			console.log(item)
			this.site = this.findItemById(item.S_ID)
			console.log(this.site)
			// this.site = this.inventory[index]
			this.showeditor = true;
		},


		updateSite(entry) {
			var that = this
			console.log(entry)
			this.working = true;
			var headers = {
				headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') }
			}
			this.$http.post('/services/edit',entry,headers)
			.then(function (response) {
				that.working = false;
				that.showeditor = false;
				that.$toastr.Add({
					title: "Success", // Toast Title
					msg: "Update successful",
					position: "toast-top-center",
					type: "success"
				});
				console.log(response)
			})
			.catch(function (error) {
				that.working = false;
				alert("There was an error processing your request.")
				that.showeditor = false;
				 console.log(error)
			})
			// alert(entry.s_id + "!!")
		},
		
		insertSite(entry) {
			var that = this
			this.working = true;
			var headers = {
				headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') }
			}
			this.$http.post('/services/add',entry,headers)
			.then(function (response) {
				that.working = false;
				that.showadder = false;
				that.showeditor = false;
				// console.log(response)
				if(response.data['ID'] != '') entry['S_ID'] = parseInt(response.data['ID']) 
				that.services.unshift(entry)
				that.newsite = that.site_template;
				that.$toastr.Add({
					title: "Success", // Toast Title
					msg: "Insert successful",
					position: "toast-top-center",
					type: "success"
				});
				console.log(response)
			})
			.catch(function (error) {
				that.working = false;
				alert("There was an error processing your request.")
				that.showadder = false;
				 console.log(error)
			})
			// alert(entry.s_id + "!!")
		},

		deleteSite(sid) {
			var that = this
			console.log("deleting")
			let payload = {'S_ID': sid}
			var headers = {
				headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') }
			}
			this.$http.post('/services/delete',payload, headers)
			.then(function (response) {
				console.log(response)
				for(var i = 0;i < that.services.length;i++) {
					if(that.services[i].S_ID == sid) {
						that.services.splice(i,1)
					}
				}
				that.showeditor = false;
				that.$toastr.Add({
					title: "Success", // Toast Title
					msg: "Deletion successful",
					position: "toast-top-center",
					type: "success"
				});
			})
			.catch(function (error) {
				that.working = false;
				alert("There was an error processing your request.")
				that.showeditor = false;
				 console.log(error)
			})			
			// alert(sid + "!!")
		},

		findItemById(sid) {
			for(var i = 0;i < this.services.length;i++) {
				if(this.services[i].S_ID == sid) {
					return this.services[i]
				}
			}				
		}	

	},
	

	mounted() {
			
	}
}
